{
  "PHONE_INPUT_LABEL": "Cell Number",
  "LOCKED_PROMPT": {
    "PRICING_MESSAGE": {
      "FEATURE_1": "Charge preauthorized cards to ensure collection of all payments"
    }
  },
  "AUTH": {
    "CLIENT_ACCOUNT_INVITE": {
      "DESCRIPTION": "You have been invited to join the <strong>{{clientAccount}}</strong> organization. Please enter the following information to complete your profile.",
      "SUBMIT": "Join Organization",
      "SUCCESS": "Joined organization successfully. Please login to continue"
    }
  },
  "NAVIGATION": {
    "LABEL": {
      "ORGANIZATION": "Organization",
      "ORGANIZATIONS": "Organizations"
    }
  },
  "BRANDING": {
    "SETTINGS": {
      "SHOW_LOGO_BACKGROUND": "Show background color behind logo",
      "COLOR_SCHEME": "Color Scheme",
      "COLORS_CONTRAST_WARNING": "Please make sure background and primary colors are contrasting to ensure that all important links are visible",
      "CUSTOM_TEXT": {
        "SUBTITLE": "These options allow you to customize the messages displayed when the auction is closed."
      }
    },
    "GENERATE_LOGO_AND_BANNER": {
      "DISCLAIMER_LOGO_BG": "Please note that the AI may not generate the exact background color you choose; it will be close, but may be a slightly different shade.",
      "BACKGROUND_COLOR": "Background Color"
    }
  },
  "CAMPAIGNS": {
    "CREATE": {
      "NO_CREDITS_MESSAGE_STAFF": "This organization has no campaign creation credits remaining. As a staff user, you can create this campaign anyway.",
      "NO_CREDITS_MESSAGE": "Your organization has no campaign creation credits remaining, contact GalaBid if you need more.",
      "CLIENT_ACCOUNT_SETTING_CREDIT_MESSAGE_ONE": "Creating this campaign will use the organization's last remaining campaign creation credit.",
      "CLIENT_ACCOUNT_SETTING_CREDIT_MESSAGE": "Creating this campaign will use one of the organization's {{credit}} remaining campaign creation credits.",
      "CLIENT_ACCOUNT": "Organization",
      "ADD_CREDIT_DIALOG": {
        "ORGANISATION": "Organization",
        "DESCRIPTION_1": "Each time an admin creates a campaign, a campaign creation credit is deducted from their organization. If an organization has used all of its credits, its admins will not be able to create new campaigns."
      }
    },
    "LIST": {
      "ORGANISATION": "Organization",
      "PENDING_ORG_WARNING_1": "You have <strong>{{count}}</strong> pending organization invite(s). Accept them in"
    }
  },
  "CLIENT_ACCOUNT": {
    "SIDENAV": {
      "LIST": "Organization List"
    },
    "PREFERRED_CONTACT_EMAIL_VERIFICATION": {
      "SUCCESS_DESCRIPTION": "You've successfully verified the preferred contact email for this organization.",
      "INVALID_DESCRIPTION": "This verification link is invalid. Please ask an organization admin to add the preferred contact email again.",
      "EXPIRED_DESCRIPTION": "This verification link has expired. Please ask an organization admin to add the preferred contact email again.",
      "RETURN_TO_DASHBOARD": "Return to Dashboard",
      "GO_TO_CLIENT_ACCOUNT": "Go to Organization"
    }
  },
  "USERS": {
    "MESSAGE": {
      "BODY": "This message template accepts some placeholders to customize the message"
    }
  },
  "NOTIFICATIONS": {
    "EDIT_DIALOG": {
      "PLACEHOLDERS_DESC": "This message template accepts some placeholders to customize the message:"
    }
  },
  "SETTINGS": {
    "GIFTAID": {
      "TITLE": "Customize Gift Aid"
    },
    "MENU": {
      "TITLE": "Customize Campaign Menu",
      "DESCRIPTION": "Here you can customize the main menu of your campaign. You can choose which buttons will be shown, add custom buttons, change their text, and change their order."
    },
    "PAYMENTS": {
      "DETECTED_DEFAULT_PAYMENT": "We've detected default payment settings in your organization, apply them now.",
      "CREDIT_CARD_PREAUTH": "Credit Card Pre-Authorization",
      "CREDIT_CARD_PREAUTH_NON_SAAS_HINT": "Pre-authorized cards are NOT automatically charged when the campaign closes.",
      "CREDIT_CARD_PREAUTH_HINT_2": "Pre-authorized cards are NOT automatically charged when the campaign closes. Charge individual pre-authorized cards in the <a href='/campaign/{{campaign_url}}/checkout'>Checkout Console.</a>"
    }
  },
  "CUSTOM_QUESTIONS": {
    "EDIT_TERMS_AND_CONDITIONS_SUBTITLE": "These are the terms your participants must agree to when registering for the campaign. Please ensure they accurately reflect your organization's requirements."
  },
  "ORGANIZATIONS": {
    "NO_SELECTION": "No organizations selected",
    "TITLE": "Organizations",
    "CREATE": "Add new organization",
    "LOADING": "Loading Organizations",
    "SEARCH": "Search Organizations",
    "CREATE_DIALOG": {
      "TITLE": "Add A New Organization",
      "DESC": "Fill in the organization's name below to start managing their campaigns.",
      "NAME": "Organization Name",
      "CREATE_SUCCESS": "Organization Created"
    },
    "DETAILS": {
      "LOGIN_ALIAS": "The login alias for this organization is ",
      "ORG_NAME": "Organization Name"
    },
    "PREFERRED_CONTACT_EMAIL_DIALOG": {
      "ADD_DESC": "Add or remove preferred contact emails for participant messages. If no email is set, participant messages will be sent to all organisation admins."
    },
    "CAMPAIGNS": {
      "LINK_CAMPAIGN_DIALOG_DESC": "Select one or more campaigns below to add them to the organization. If you select an campaign that already belongs to another organization, it will be moved to this one.",
      "ORG_NAME": "Organization Name"
    },
    "GENERAL": {
      "ORGANIZATION": "Organization"
    },
    "ADMINS": {
      "INVITE_ADMIN_DIALOG": {
        "CAN_EDIT": "Can add and edit organization admins"
      },
      "REMOVE_ADMIN_DESC": "Are you sure you want to remove this organization admin?",
      "EDIT_ADMIN_DIALOG": {
        "DESC": "Admins will have full access to view and edit campaigns for the organization through the admin dashboard.\n\nFill in the details below to create an organization admin."
      }
    },
    "PAYMENTS": {
      "EXPRESS_DISABLED": "Express connect is not enabled for this organization, however express stripe accounts have been detected.",
      "STANDARD_DISABLED": "Standard connect is not enabled for this organization, however standard stripe accounts have been detected.",
      "SHARE_DESC": "This will allow you to share your stripe account with another organization on GalaBid.",
      "SEARCH_ORG": "Search for an organization"
    }
  },
  "USER_ACCOUNTS": {
    "CLIENT_ACCOUNTS": "Organizations",
    "NO_CLIENT_ACCOUNTS": "No Organizations"
  },
  "ADD_PAYMENT_DIALOG": {
    "PAYMENT_FEE_AMOUNT_OPTIONAL_TOGGLE": "Would you be happy to cover the {{serviceFeeLabel}} of {{totalFee}}? This helps the organizer to maximize their fundraising profits."
  },
  "LOADER": {
    "UPDATING_ORGANIZATION": "Updating Organization"
  },
  "FORMS": {
    "ERROR": {
      "INVALID_COLOR": "Must be a valid color"
    }
  },
  "ADD_WIDGET_DIALOG": {
    "BACKGROUND_COLOR": "Background Color",
    "TEXT_COLOR": "Text Color"
  },
  "ITEMS": {
    "EDIT": {
      "RAFFLE_SAAS_MESSAGE_1": "Name, Address & Registration/Charity Number of the Organization running the draw.",
      "IOC_SHOP_LABEL_COLOR": "IOC Shop Label Color",
      "BID_STRENGTH_ENABLED_TOOLTIP": "Show a color-coded indicator of how competitive a bid is",
      "ADMIN_PURCHASE_NOTIFICATION_ENABLED_TOOLTIP": "Send an automated email to all members in your organization when this ticket is purchased",
      "ITEM_FULFILMENT_TITLE": "Item Fulfillment"
    }
  },
  "DOCUMENTS": {
    "VISUAL_REG_INST_DESC": "Customize and preview registration instructions.",
    "REGISTRATION_INSTRUCTIONS": {
      "COLOR": "Registration Instructions Color",
      "PRINT_BODY": "Are you sure you want to print these registration instructions? Remember to enable Background Graphics in More Settings inside the print dialog if you do not see all the colors."
    }
  },
  "SETUP_GUIDE": {
    "AI_PROMPT_PLACEHOLDER_BRANDING_FORM": "Add a brief description of the branding colors or theme and I will generate the colors",
    "STEPS": {
      "TELL_US_ABOUT_YOUR_CAMPAIGN": {
        "DESCRIPTION": "Add your event details to personalize your campaign"
      },
      "SETUP_BRANDING": {
        "DESCRIPTION": "Add a logo, a banner and update colors for your campaign"
      }
    },
    "SUBSTEPS": {
      "SET_CAMPAIGN_COLORS": {
        "TITLE": "Set campaign colors"
      }
    }
  },
  "PRESENTER": {
    "VISIBILITY_PUBLIC": "All organizations",
    "VISIBILITY_CLIENT_ACCOUNT": "Select organizations",
    "COLOR_TOKENS": {
      "PRIMARY_COLOR": "Primary Color",
      "BACKGROUND_COLOR": "Background Color",
      "ACCENT_COLOR": "Accent Color",
      "BANNER_BACKGROUND_COLOR": "Banner Background Color",
      "WARNING_COLOR": "Warning Color",
      "SUCCESS_COLOR": "Success Color",
      "CUSTOM_COLOR": "Custom Color"
    },
    "CUSTOM_COLOR_HEX": "Custom Color",
    "TEST_THEME": {
      "DESCRIPTION": "The below colors are for test purposes, the actual colors will be taken from the selected auction"
    }
  }
}
